// @flow
import { CommonMapper } from 'mappers/common';
import { RestaurantMapper } from 'mappers/restaurant';
import { RestaurantActionTypes } from './actionTypes';

const getMenuCategories = url_slug => (dispatch, getState, { api }) => {
  dispatch({
    type: RestaurantActionTypes.CATEGORY.FETCH,
    payload: {},
    test: api
      .post(`restaurantMenus.json`, { url_slug: url_slug })
      .then(res => {
        const response = res.data.result.data || {};
        const restaurantCategories = response.restaurantMenus || [];
        const mediaPath = CommonMapper.extractMediaPath(response);
        dispatch({
          type: RestaurantActionTypes.CATEGORY.SUCCESS,
          payload: RestaurantMapper.mapRestaurantCategories(
            restaurantCategories,
            mediaPath
          ),
        });

        return res.data;
      })
      .catch(error => {
        dispatch({
          type: RestaurantActionTypes.CATEGORY.FAILURE,
          error,
        });
      }),
  });
};

const getGalleryForRestaurant = (restaurant_url_slug: string) => (
  dispatch,
  getState,
  { api }
) => {
  dispatch({
    type: RestaurantActionTypes.GALLERY.FETCH,
    payload: {},
    test: api
      .post(`galleries.json`, {
        url_slug: restaurant_url_slug,
        model: 'restaurant',
      })
      .then(res => {
        const response = res.data.data || {};
        const galleryImages = response.galleries || [];
        const mediaPath = CommonMapper.extractMediaPath(response);

        dispatch({
          type: RestaurantActionTypes.GALLERY.SUCCESS,
          payload: RestaurantMapper.mapRestaurantGalleryData(
            galleryImages,
            mediaPath
          ),
        });

        return res.data;
      })
      .catch(error => {
        dispatch({
          type: RestaurantActionTypes.GALLERY.FAILURE,
          error,
        });
      }),
  });
};

const getAllRestaurants = () => (dispatch, getState, { api }) => {
  dispatch({
    type: RestaurantActionTypes.ALL_RESTAURANTS.FETCH,
    payload: {},
    test: api
      .post(`restaurantList.json`)
      .then(res => {
        const response = res.data.data || {};
        const restaurantList = response.restaurant_list || [];
        const mediaPath = CommonMapper.extractMediaPath(response);
        dispatch({
          type: RestaurantActionTypes.ALL_RESTAURANTS.SUCCESS,
          payload: RestaurantMapper.mapRestaurantsList(
            restaurantList,
            mediaPath
          ),
        });

        return res.data;
      })
      .catch(error => {
        dispatch({
          type: RestaurantActionTypes.ALL_RESTAURANTS.FAILURE,
          error,
        });
      }),
  });
};

const getBannerDetails = url_slug => (dispatch, getState, { api }) => {
  dispatch({
    type: RestaurantActionTypes.BANNER.FETCH,
    payload: {},
    test: api
      .post(`restaurantDetail.json`, { restaurant_url_slug: url_slug })
      .then(res => {
        const response = res.data.data || {};
        const restaurantDetails = response.restaurant_details || [];
        const mediaPath = CommonMapper.extractMediaPath(response);
        dispatch({
          type: RestaurantActionTypes.BANNER.SUCCESS,
          payload: RestaurantMapper.mapRestaurantDetailsBanner(
            restaurantDetails,
            mediaPath
          ),
        });
      })
      .catch(error => {
        dispatch({
          type: RestaurantActionTypes.BANNER.FAILURE,
          error,
        });
      }),
  });
};

const getBeers = url_slug => (dispatch, getState, { api }) => {
  dispatch({
    type: RestaurantActionTypes.BANNER.FETCH,
    payload: {},
    test: api
      .post(`getBeers.json`, { restaurant_outlet_slug: url_slug })
      .then(res => {
        const response = res.data.data || [];
        const beerData = response.beers;
        const mediaPath = CommonMapper.extractMediaPath(response);
        dispatch({
          type: RestaurantActionTypes.BEER.SUCCESS,
          payload: RestaurantMapper.mapBeerDetails(beerData, mediaPath),
        });
      })
      .catch(error => {
        dispatch({
          type: RestaurantActionTypes.BEER.FAILURE,
          error,
        });
      }),
  });
};

const toggleModal = value => dispatch => {
  dispatch({
    type: RestaurantActionTypes.TOGGLE_MENU_MODAL.TOGGLE_MODAL,
    payload: value,
  });
};

export const RestaurantActions = {
  getGalleryForRestaurant,
  getMenuCategories,
  getAllRestaurants,
  getBannerDetails,
  getBeers,
  toggleModal,
};
